import React, { useContext, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import Button from "../../components/ui/Button";
import calLogo from "../../assets/images/calender.svg";
import upIcon from "../../assets/images/up-icon.svg";
import downIcon from "../../assets/images/down-icon.svg";
import { set, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ErrorMessage } from "@hookform/error-message";
import toast from "react-hot-toast";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import moment from "moment";
import authContext from "../../context/authContext";
import addIcon from '../../assets/images/add-icon.svg';
import CustomReactSelect from "../../components/ui/CustomReactSelect";
import CustomInput from "../../components/ui/CustomInput";
import { PAYMENT_METHOD } from "../../utils/Helper";


type PaymentRecordType = {
  isFinalized: boolean
  recepint: any[];
  members: any[];
  callback: () => void;
};

type PaymentFormValues = {
  date: Date | null;
  amount: number | "";
  method: { value: string; label: string } | null;
  payer: { value: string; label: string } | null;
  recipient: { value: string; label: string } | null;
  description: string;
  username: string;
};

const AddPaymentRecordValidation: any = yup.object().shape({
  date: yup
    .date()
    .nullable()
    .required("Date is required"),
  amount: yup
    .number()
    .typeError("Amount must be a number")
    .positive("Amount must be greater than zero")
    .required("Amount is required"),
  method: yup.object().required("Method is required"),
  payer: yup.object().required("Payer is required"),
  recipient: yup.object().nullable().required("Recipient is required"),
  description: yup
    .string()
    .test(
      "no-more-than-6-consecutive-digits",
      "Please do not enter more than 6 consecutive numbers.",
      (value) => {
        if (!value) return true; // allow empty
        return !/\d{7,}/.test(value); // fail if 6+ digits in a row
      }
    ),
});


const PaymentRecord: React.FC<PaymentRecordType> = ({ isFinalized, recepint, members, callback }) => {
  const [showLinks, setShowLinks] = useState(false);
  const [paymentLinksForSelectedUser, setPaymentLinksForSelectedUser] = useState<any>([]);
  const [paypalUsername, setPaypalUsername] = useState("");
  const [isExpanded, setIsExpanded] = useState(true);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [paymentLink, setPaymentLink] = useState('');
  const manualPaymentCreate = useMakeRequest();
  const getPaymentMethod = useMakeRequest();
  const savePaymentMethod = useMakeRequest();
  const getPaymentMethodLinks = useMakeRequest();
  const deletePaymentMethodLinks = useMakeRequest();

  let profile: any = useContext(authContext);
  profile = profile?.data;


  const baseRecipientOptions = React.useMemo(() => {
    return recepint;
  }, [recepint]);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm<PaymentFormValues>({
    resolver: yupResolver(AddPaymentRecordValidation),
    defaultValues: {
      date: new Date(),
      amount: "",
      method: null,
      payer: null,
      recipient: null,
      description: "",
      username: "",
    },
  });

  const filteredRecipients = React.useMemo(() => {
    return baseRecipientOptions;
  }, [baseRecipientOptions]);

  console.log("members: ", members)



  useEffect(() => {
    getPaymentMethodLinks.makeRequest({
      payload: { hh_id: profile?.hh_member?.household?.id },
      url: ApiConstants?.getPaymentMethodLinks,
    }).then((res) => {
      console.log("res: : : ", res)
      if (res?.data) {
        let arr = res?.data.sort((a: { user_id: any; }, b: any) => (a.user_id === profile?.id ? 1 : -1));
        setPaymentLinksForSelectedUser(arr)
      }
    })
  }, [])


  useEffect(() => {
    if (watch("recipient")?.value) {
      getPaymentMethod.makeRequest({
        url: ApiConstants?.getPaymentMethod,
        payload: { receiver_user_id: watch("recipient")?.value }
      })
    }

  }, [watch("recipient")])

  useEffect(() => {

    if (getPaymentMethod?.status) {
      const data = getPaymentMethod?.data;
      if (data?.data) {
        const methods = data?.data?.map((method: any) => ({ value: method?.type, label: method?.type == 1 ? "PayPal" : method?.type == 2 ? "Venmo" : "CashApp" }));
        setPaymentMethod(methods)
        const payment_link = data?.data?.filter((link: any) => link.type == methods[0]?.value);
        setPaymentLink(payment_link[0]?.payment_link || '')
      }
    }

  }, [getPaymentMethod.status])


  const onSubmit = (data: PaymentFormValues) => {
    console.log("data; ", data)
    const isPayerJoint = data?.payer?.value === "-1" || data?.payer?.value === "01" || data?.payer?.label === "Joint Account";
    const isRecipientJoint = data?.recipient?.value === "-1" || data?.recipient?.value === "01" || data?.recipient?.label === "Joint Account";
    const payload = {
      hh_id: profile?.hh_member?.household?.id, // or pass via props/context
      amount: Number(data.amount),
      payment_date: data.date
        ? moment(data.date).format("YYYY-MM-DD")
        : null,
      description: data.description || "",
      from_id: isPayerJoint ? -1 : data?.payer?.value,
      to_id: isRecipientJoint ? -1 : data.recipient?.value,
      is_joint_account: isPayerJoint,
      method: watch("method")?.value
    };

    console.log("Payment saved:", payload);
    manualPayment(payload);

  };

  const manualPayment = (payload: any) => {
    toast.promise(
      manualPaymentCreate.makeRequest({
        payload: payload,
        url: ApiConstants?.manualPayment,
      }),
      {
        loading: "Processing...",
        success: (data: any) => data.message,
        error: (error: any) => error.message,
      }
    );
    reset();
    callback()
  }


  const makeInAppPayment = (payload: any) => {
    toast.promise(
      savePaymentMethod.makeRequest({
        payload: payload,
        url: ApiConstants?.savePaymentMethod, // <-- replace with your API constant name
      }),
      {
        loading: "Verifying in-app payment...",
        success: (data: any) => data.message || "In-app payment successful!",
        error: (error: any) => error.message || "Failed to process payment.",
      }
    );
  };


  // useEffect(() => {
  //   if (savePaymentMethod?.status) {
  //     console.log("In-app payment saved:", savePaymentMethod?.data);
  //     if (savePaymentMethod?.data) {
  //       let paymentLink = `${savePaymentMethod?.data?.data?.payment_link}/${watch('amount')}`
  //       console.log("paymentLink ", paymentLink)
  //       window.open(paymentLink, "_blank");
  //     }
  //   }
  // }, [savePaymentMethod.status])

  const _addPaymentMethod = (payload: any) => {

    savePaymentMethod.makeRequest({
      payload: payload,
      url: ApiConstants?.savePaymentMethod, // <-- replace with your API constant name
    }).then((res) => {
      setPaymentLinksForSelectedUser([])
      getPaymentMethodLinks.makeRequest({
        payload: { hh_id: profile?.hh_member?.household?.id },
        url: ApiConstants?.getPaymentMethodLinks,
      }).then((res) => {
        if (res?.data) {
          let arr = res?.data.sort((a: { user_id: any; }, b: any) => (a.user_id === profile?.id ? 1 : -1));
          setPaymentLinksForSelectedUser(arr)
        }
      })
    })
    setPaypalUsername("")
  };

  return (
    <div className="page-padding-x my-3">
      {/* <div className="col-6">
        <Button
          onClick={() => setVisiblePaymentMethod(!visiblePaymentMethod)}
          className="com-btn mt-2 mb-3 me-4"
          style={{ width: "90%" }}
          type="submit"
        >
          Add Payment Method
        </Button>
      </div> */}
      {/* <div className="payment-form mb-4">
        <div className="form-header" onClick={() => setVisiblePaymentMethod(!visiblePaymentMethod)}>
          <h2 className="dropdown-title">Payment Method</h2>
          <img src={addIcon} alt="Arrow" className="arrow-icon" />
        </div>

        {visiblePaymentMethod &&
          <div className="col-12 p-3">
            <div className="com-input-grp d-flex mt-2">
              <label className="form-label">Payments may be made by any method, including cash or bank transfer. For convenience, payments link can be entered and shown to other users here.</label>
            </div>
            {paymentLinksForSelectedUser?.length > 0 ? (
              paymentLinksForSelectedUser.map((ele: any) => {
                const isCurrentUser = ele.user_id == profile?.id
                return (
                  <div key={ele.user_id} className="com-input-grp mt-4">
                    <label className="form-label d-block mb-2" style={{ fontWeight: '600' }}>
                      {ele.user_details?.name}
                    </label>

                    {ele?.paymentMethods?.map((method: any) => (
                      <div
                        key={method.id}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '20px',
                          // marginBottom: '2px',
                          paddingLeft: '0'
                        }}
                      >
                        <label
                          className="form-label d-block"
                          style={{
                            margin: 0,
                            minWidth: '80px',
                            fontWeight: '500'
                          }}
                        >
                          {method.type}
                        </label>

                        <a
                          // href={method?.payment_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            padding: '0',
                            backgroundColor: 'transparent',
                            color: '#007bff',
                            textDecoration: 'none',
                            fontWeight: '400',
                            whiteSpace: 'nowrap',
                            flex: 1
                          }}
                        >
                          Link/ {method?.payment_link}
                        </a>

                        {isCurrentUser ? (
                          <span className="btn-delete" style={{ cursor: "pointer" }}
                            onClick={() => {
                              console.log("payment_method_id", method.id)
                              console.log("user_id", profile?.id)
                              toast.promise(
                                deletePaymentMethodLinks.makeRequest({
                                  payload: {
                                    "payment_method_id": method.id,
                                    "user_id": profile?.id
                                  },
                                  url: ApiConstants?.deletePaymentMethodLinks, // <-- replace with your API constant name
                                }).then((res) => {
                                  setPaymentLinksForSelectedUser([])
                                  getPaymentMethodLinks.makeRequest({
                                    payload: { hh_id: profile?.hh_member?.household?.id },
                                    url: ApiConstants?.getPaymentMethodLinks,
                                  }).then((res) => {
                                    if (res?.data) {
                                      let arr = res?.data.sort((a: { user_id: any; }, b: any) => (a.user_id === profile?.id ? 1 : -1));
                                      setPaymentLinksForSelectedUser(arr)
                                    }
                                  })
                                }),
                                {
                                  loading: "Deleting links...",
                                }
                              );
                            }}>
                            <i className="icon-delete"></i>
                          </span>
                        ) : (
                          <span style={{ width: '50px' }}></span>
                        )}
                      </div>
                    ))}
                  </div>
                )
              })
            ) : (
              <div
                className="com-input-grp mt-3"
                style={{ alignSelf: 'center' }}
              >
                <label className="form-label-info d-block">
                  {"No Payment Method available for any user."}
                </label>
              </div>
            )}


            <div className="com-input-grp mt-4">
              <label className="form-label d-block mb-2">Payment Method</label>
              <input
                type="text"
                className="form-control mb-3"
                placeholder="Enter payment method"
                value={paymentMethodInput}
                onChange={(e) => setPaymentMethodInput(e.target.value)}
              />

              <label className="form-label d-block mb-2">{"Payment link"}</label>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                <div style={{ flex: 1 }}>
                  <input
                    type="url"
                    className="form-control"
                    placeholder={`Enter payment link`}
                    value={paypalUsername}
                    onChange={handleChange}
                  />
                  {paymentMethodLinkError && <p className="valid-error" style={{ marginTop: '5px', marginBottom: 0 }}>{paymentMethodLinkError}</p>}
                </div>
                <Button
                  loading={savePaymentMethod?.loading}
                  onClick={() => {
                    const payload = {
                      type: paymentMethodInput,
                      value: paypalUsername,
                      hh_id: profile?.hh_member?.household?.id
                    };
                    _addPaymentMethod(payload);
                  }}
                  className="com-btn p-1"
                  style={{ minWidth: "60px", flexShrink: 0 }}
                >
                  Add
                </Button>
              </div>

            </div>



            <>

              <p style={{
                fontStyle: 'italic',
                color: '#999',
                fontSize: '13px',
                marginTop: '10px',
                marginBottom: 0
              }}>
                Justivide does not guarantee the accuracy of any links displayed above or endorse the services provided by any of the apps listed.
              </p>
            </>

          </div>
        }
      </div> */}

      <div className="payment-form">
        <div 
          className="form-header" 
          role="button"
          tabIndex={0}
          onClick={() => setIsExpanded(!isExpanded)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setIsExpanded(!isExpanded);
            }
          }}
        >
          <h2 className="dropdown-title">Add Payments</h2>
          <img src={addIcon} alt="Arrow" className="arrow-icon" />
        </div>

        {isExpanded && (
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row gy-3 m-2">
              {/* Date */}
              <div className="col-6">
                <div className="com-input-grp">
                  <label className="form-label d-block">Date</label>
                  <DatePicker
                    className="form-control"
                    placeholderText="MM/DD/YYYY"
                    timeFormat="MM DD YYYY"
                    onKeyDown={(e: any) => e.preventDefault()}
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={50}
                    selected={watch("date")}
                    showIcon
                    icon={
                      <>
                        <img className="calIcon" src={calLogo} alt="" />
                      </>
                    }
                    onChange={(date) => setValue("date", date)}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="date"
                    render={({ message }) => (
                      <p className="valid-error">{message}</p>
                    )}
                  />
                </div>
              </div>
              {/* <div className="col-6">
              <div className="com-input-grp">
                <label className="form-label d-block">Date</label>
                <DatePicker
                  className="form-control"
                  selected={date}
                  onChange={(selectedDate) => setDate(selectedDate)}
                  placeholderText="MM/DD/YYYY"
                  showIcon
                  icon={<img className="calIcon" src={calLogo} alt="" />}
                />
              </div>
            </div> */}

              {/* Amount */}
              <div className="col-6">
                <div className="com-input-grp">
                  <label className="form-label d-block">Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter amount"
                    min={0}
                    step="any"
                    {...register("amount")}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="amount"
                    render={({ message }) => (
                      <p className="valid-error">{message}</p>
                    )}
                  />
                </div>
              </div>

              {/* Payer (logged-in user) */}
              <div className="col-6">

                <CustomReactSelect
                  label="Payer"
                  value={watch("payer")}
                  onChange={(val) => {
                    if (val?.label !== watch('recipient.label')) {
                      setValue("payer", val)
                    } else {
                      toast.error(`The Payer must be different from the Recipient.`)
                    }
                  }}
                  placeholder="Select Payer"
                  options={members}
                  className="com-r-select"
                  classNamePrefix="com-r-select"
                  closeMenuOnScroll={true}
                  closeMenuOnSelect={true}
                  error={errors}
                  errorName={"payer"}
                  tooltip={{
                    id: 'payer-tooltip',
                    content: 'Select the payer for this payment.',
                    place: 'top'
                  }}
                />
              </div>

              {/* Recipient */}
              <div className="col-6">
                <div className="com-input-grp">
                  <label className="form-label d-block">Recipient</label>
                  <div className="custom-select">
                    <Select
                      value={watch("recipient")}
                      onChange={(val) => {
                        if (val?.label !== watch('payer.label')) {
                          setValue("recipient", val, { shouldValidate: true, shouldTouch: true })
                          setPaymentMethod([]);
                          setPaymentLink('');
                          setShowLinks(false);
                        } else {
                          toast.error(`The Recipient must be different from the Payer.`)
                        }

                      }}
                      options={filteredRecipients}
                      placeholder="Select Recipient"
                      className="com-r-select"
                      classNamePrefix="com-r-select"
                    />
                  </div>
                  <ErrorMessage
                    errors={errors}
                    name="recipient"
                    render={({ message }) => (
                      <p className="valid-error">{message}</p>
                    )}
                  />
                </div>
              </div>

              {/* Method (Stripe only) */}
              <div className="col-12">
                <div className="com-input-grp">
                  <label className="form-label d-block">Method</label>
                  <div className="custom-select">
                    <Select
                      value={watch("method")}
                      onChange={(val) => {
                        if (val) setValue("method", val);
                        setShowLinks(false)
                      }}
                      options={PAYMENT_METHOD}
                      className="com-r-select"
                      classNamePrefix="com-r-select"
                      placeholder="Select Method"
                      menuPosition="fixed"
                      menuShouldScrollIntoView={false}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 })
                      }}
                    />
                  </div>
                  <ErrorMessage
                    errors={errors}
                    name="method"
                    render={({ message }) => (
                      <p className="valid-error">{message}</p>
                    )}
                  />
                </div>

              </div>

              {/* Description */}
              <div className="col-12">

                <CustomInput
                  label="Description"
                  type="text"
                  placeholder="Enter description"
                  {...register('description')}
                  error={errors.description?.message}
                  tooltip={{
                    id: "description-tooltip",
                    content: "Add a brief description for the payment (optional).",
                    place: "top"
                  }}
                />

                {/* <div className="com-input-grp">
                  <label className="form-label d-block">Description</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter description"
                    {...register("description")}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="description"
                    render={({ message }) => (
                      <p className="valid-error">{message}</p>
                    )}
                  />
                </div> */}
              </div>

              {/* Save Button */}
              <div className="col-12">
                <Button
                  className="com-btn mt-2 me-4"
                  style={{ width: "100%" }}
                  type="button"
                  onClick={() => {
                    // if (!isFinalized) {
                    //   toast.error("You havn't finalize the contribution. please finalize before making the payment.");
                    //   return;
                    // }
                    handleSubmit(onSubmit)();
                  }}

                >
                  Save
                </Button>
              </div>

              {(watch("recipient")?.value !== "-1" && paymentMethod?.length > 0) &&
                <div className="col-12">
                  <Button
                    className="com-btn com-btn-outline me-4"
                    style={{ width: "100%" }}
                    type="button"
                    onClick={handleSubmit((data) => {
                      // if (!isFinalized) {
                      //   toast.error("You havn't finalize the contribution. please finalize before making the payment.");
                      //   return;
                      // }
                      setShowLinks(true)
                    })}
                  >
                    Make a new payment
                  </Button>
                </div>
              }
              {showLinks &&
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',   // centers horizontally
                    alignItems: 'center',       // centers vertically
                  }}>
                  {paymentMethod?.length > 0 ? paymentMethod?.map((method: any) => (
                    <div className="com-input-grp d-flex" key={method.value}>
                      <label className="form-label-secondary">{method.label}{" "}
                        :{" "}
                        {getPaymentMethod?.status ? (
                          <a
                            href={paymentLink ? `${paymentLink}/${watch('amount')}` : '#'}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => setShowLinks(false)}
                            style={{
                              display: 'inline-block',
                              padding: '6px 12px',
                              backgroundColor: '#007bff',
                              color: 'white',
                              textDecoration: 'none',
                              borderRadius: '6px',
                              fontWeight: '500',
                            }}
                          >
                            Pay With {method.label}
                          </a>
                        ) : (
                          'N/A'
                        )}
                      </label>
                    </div>
                  )) :
                    <div className="com-input-grp d-flex align-self-center">
                      <label className="form-label-secondary">No payment methods available.</label>
                    </div>
                  }
                </div>
              }
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default PaymentRecord;
